export const KEY_PRESS_MIN_DELAY: number = 5
export const KEY_PRESS_MAX_DELAY: number = 15
